import { render } from "./ProfileInfoCard.vue?vue&type=template&id=613f1a1a"
import script from "./ProfileInfoCard.vue?vue&type=script&lang=js"
export * from "./ProfileInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__